module.exports = __webpack_public_path__ + "static/Slide02@3x.36e3d1e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Slide02@3x.png
// module id = 707
// module chunks = 216210090109534